import { routerStyxie } from '@/router/styxieBridge'

// `new` is intentionally absent: widget creation happens in the index page's
// modal; the /gb/widgets/new route no longer exists.
Styxie.Initializers.MobileWidgets = routerStyxie({ actions: ['index', 'edit']})
